import { useForm } from "react-hook-form";
import {
  Wrapper,
  Header,
  HeaderContent,
  HeaderIcon,
  HeaderTitle,
  HeaderSubtitle,
  CloseButton,
  Body,
  Section,
  SectionTitleWrap,
  SectionMarker,
  SectionTitle,
  SectionNote,
  GridTwoCols,
  InputGroup,
  Label,
  Required,
  InputWrapper,
  IconLeft,
  Input,
  Notice,
  NoticeIcon,
  NoticeTitle,
  NoticeText,
  Footer,
  CancelButton,
  SubmitButton,
  ErrorText,
  RadioGroup,
} from "./regist.modal.style";
import { UserProfile } from "../../../view/contents/user/user.list";
import { useEffect } from "react";
import { fetchUserEditProfile, ResponseData } from "../../../api/admin";
import { fetchUpdatePasswordAdmin } from "../../../api/auth";
import { formatPhoneNumber } from "../../../util/util";

interface ModalProps {
  closedHandler: () => void;
  user: UserProfile;
}

const ModifyModal = ({ closedHandler, user }: ModalProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm();

  console.log(user);

  const onSubmit = async (data: any) => {
    const adminUserId = localStorage.getItem("userId") ?? "";
    const responseData: ResponseData = {
      adminUserId,
      userId: user.userId,
      username: data.userName, // ✅ 변경된 이름 반영
      userEmail: data.userEmail ?? "", // ✅ 이메일 입력란이 있다면 반영 (없으면 "")
      phoneNumber: data.phoneNumber ?? "",
      jobPosition: data.jobPosition,
      permission: data.role === "admin" ? "admin" : "client", // ✅ 권한
      department: data.department,
      disable: false,
    };

    // 비밀번호가 제공된 경우에만 비밀번호를 변경
    if (data.password) {
      try {
        const res = await fetchUpdatePasswordAdmin(user.userId, data.password);
        console.log("비밀번호 변경 성공:", res);
        alert("비밀번호가 성공적으로 변경되었습니다.");
      } catch (err) {
        console.error("비밀번호 변경 실패:", err);
        alert("비밀번호 변경에 실패했습니다. 다시 시도해주세요.");
      }
    }

    try {
      const res = await fetchUserEditProfile(responseData);
      console.log("res", res);
      alert("구성원이 성공적으로 수정되었습니다.");
      closedHandler();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (user) {
      reset({
        userAccount: user.userAccount,
        userName: user.userName,
        department: user.department, // user에 없다면 빈 문자열
        jobPosition: user.jobPosition,
        userEmail: user.userEmail,
        phoneNumber: user.phoneNumber,
        role: user.isAdmin ? "admin" : "user",
      });
    }
  }, [user, reset]);

  const phoneNumberField = register("phoneNumber");

  return (
    <Wrapper onSubmit={handleSubmit(onSubmit)}>
      <Header>
        <HeaderContent>
          <div className="title">
            <HeaderIcon>
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
            </HeaderIcon>
            <div>
              <HeaderTitle>구성원 수정</HeaderTitle>
              <HeaderSubtitle>구성원 정보를 수정해주세요</HeaderSubtitle>
            </div>
          </div>
          <CloseButton type="button" aria-label="닫기" onClick={closedHandler}>
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </CloseButton>
        </HeaderContent>
      </Header>
      <Body>
        <Section>
          <SectionTitleWrap>
            <SectionMarker />
            <SectionTitle>계정 정보</SectionTitle>
            <SectionNote>비밀번호 변경 시에만 입력해주세요</SectionNote>
          </SectionTitleWrap>
          <GridTwoCols>
            <InputGroup>
              <Label htmlFor="modify-userAccount">아이디</Label>
              <InputWrapper>
                <IconLeft aria-hidden="true">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 4h16v16H4zM8 8h8M8 12h5M8 16h3"
                    />
                  </svg>
                </IconLeft>
                <Input
                  id="modify-userAccount"
                  type="text"
                  readOnly
                  {...register("userAccount", { required: true })}
                  style={{ backgroundColor: "#f5f5f5", cursor: "not-allowed" }} // UX 개선용 스타일 (선택)
                />
              </InputWrapper>
            </InputGroup>
            <InputGroup></InputGroup>
            <InputGroup>
              <Label htmlFor="modify-password">비밀번호</Label>
              <InputWrapper>
                <IconLeft aria-hidden="true">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                </IconLeft>
                <Input
                  id="modify-password"
                  type="password"
                  {...register("password", {
                    pattern: {
                      value:
                        /^(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+={}:;"'<>,.?/-]).{10,}$/,
                      message:
                        "비밀번호는 최소 10자 이상, 소문자, 숫자, 특수기호가 포함되어야 합니다.",
                    },
                  })}
                />
              </InputWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="modify-confirmPassword">비밀번호 확인</Label>
              <InputWrapper>
                <IconLeft aria-hidden="true">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </IconLeft>
                <Input
                  id="modify-confirmPassword"
                  type="password"
                  {...register("confirmPassword", {
                    validate: (value) =>
                      value === watch("password") ||
                      "비밀번호가 일치하지 않습니다",
                  })}
                />
              </InputWrapper>
            </InputGroup>
          </GridTwoCols>
        </Section>
        <Section>
          <SectionTitleWrap>
            <SectionMarker />
            <SectionTitle>구성원 정보</SectionTitle>
            <SectionNote>(*) 필수 입력 항목</SectionNote>
          </SectionTitleWrap>
          <GridTwoCols>
            <InputGroup>
              <Label htmlFor="modify-userName">
                이름 <Required>*</Required>
              </Label>
              <InputWrapper>
                <IconLeft aria-hidden="true">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </IconLeft>
                <Input
                  id="modify-userName"
                  type="text"
                  {...register("userName", { required: true })}
                />
              </InputWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="modify-department">
                부서명 <Required>*</Required>
              </Label>
              <InputWrapper>
                <IconLeft aria-hidden="true">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 3h6v5H9zM3 16h6v5H3zM15 16h6v5h-6zM12 8v4M6 16v-4h12v4"
                    />
                  </svg>
                </IconLeft>
                <Input
                  id="modify-department"
                  type="text"
                  {...register("department", {
                    required: "부서는 필수 입력입니다.", // ✅ 필수 조건 추가
                  })}
                />
              </InputWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="modify-jobPosition">직위</Label>
              <InputWrapper>
                <IconLeft aria-hidden="true">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 7V5a2 2 0 012-2h2a2 2 0 012 2v2M3 7h18v13H3zM3 11l9 4 9-4M12 13v4"
                    />
                  </svg>
                </IconLeft>
                <Input
                  id="modify-jobPosition"
                  type="text"
                  {...register("jobPosition")}
                />
              </InputWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="modify-userEmail">이메일</Label>
              <InputWrapper>
                <IconLeft aria-hidden="true">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </IconLeft>
                <Input
                  id="modify-userEmail"
                  type="email"
                  {...register("userEmail")}
                />
              </InputWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="modify-phoneNumber">전화번호</Label>
              <InputWrapper>
                <IconLeft aria-hidden="true">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                </IconLeft>
                <Input
                  id="modify-phoneNumber"
                  type="text"
                  maxLength={13}
                  placeholder="010-1234-5678"
                  {...phoneNumberField}
                  onChange={(e) => {
                    e.target.value = formatPhoneNumber(e.target.value);
                    phoneNumberField.onChange(e);
                  }}
                />
              </InputWrapper>
            </InputGroup>
            <InputGroup>
              <Label as="div">
                권한 <Required>*</Required>
              </Label>
              <RadioGroup>
                <label>
                  <input
                    type="radio"
                    value="user"
                    {...register("role", { required: true })}
                  />
                  사용자
                </label>
                <label>
                  <input
                    type="radio"
                    value="admin"
                    {...register("role", { required: true })}
                  />
                  관리자
                </label>
              </RadioGroup>
            </InputGroup>
          </GridTwoCols>
        </Section>
        {errors.password && (
          <ErrorText>
            {typeof errors.password.message === "string"
              ? errors.password.message
              : ""}
          </ErrorText>
        )}
        {!errors.password && errors.confirmPassword && (
          <ErrorText>
            {typeof errors.confirmPassword.message === "string"
              ? errors.confirmPassword.message
              : ""}
          </ErrorText>
        )}
        {errors.department && (
          <ErrorText>{errors.department.message as string}</ErrorText>
        )}
        <Notice>
          <NoticeIcon fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </NoticeIcon>
          <div>
            <NoticeTitle>수정 안내</NoticeTitle>
            <NoticeText>
              아이디는 변경할 수 없습니다. 비밀번호를 변경하려면 10자 이상이며
              소문자, 숫자, 특수기호를 포함한 새 비밀번호를 입력해주세요.
            </NoticeText>
          </div>
        </Notice>
      </Body>
      <Footer>
        <CancelButton type="button" onClick={closedHandler}>
          취소
        </CancelButton>
        <SubmitButton type="submit">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
          <span>수정</span>
        </SubmitButton>
      </Footer>
    </Wrapper>
  );
};

export default ModifyModal;
